import { Component, OnInit } from '@angular/core';
import { ELEMENTS, ZONES_TYPES } from 'src/app/data/elements';
import { OptionsService } from 'src/app/service/options.service';
import { ElementsService } from 'src/app/service/elements.service';
import { CanvasOptionsService } from 'src/app/service/canvas-options.service';
import { UndoService } from 'src/app/service/undo.service';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';
import { findReadVarNames } from '@angular/compiler/src/output/output_ast';
import { ZonesPropertiesService } from 'src/app/service/zones-properties.service';

@Component({
  selector: 'app-zones-list',
  templateUrl: './zones-list.component.html',
  styleUrls: ['./zones-list.component.less']
})
export class ZonesListComponent implements OnInit {


  zonesArray=[];
  addZone:boolean=false;
  zonesTypes=ZONES_TYPES;
  startingZoneType=1;
  subscription: Subscription;

  activeZone:any=null;

  constructor(
    private optionsService: OptionsService,
    private elementsService: ElementsService,
    private canvasOptionsService: CanvasOptionsService,
    private zonesPropertiesService: ZonesPropertiesService,
    private undoService:UndoService
    ) { 
      
      this.zonesArray=ELEMENTS.zones; 
      
      this.subscription = this.canvasOptionsService.canvasOptions$.subscribe(data => {
        this.activeZone=data.activeZone;
        
      });
    }

  ngOnInit() {       
    
  }

  changeNames(){
    for(let i=0; i<this.zonesArray.length;i++){
      let zoneName=this.zonesPropertiesService.getZoneTypeById(this.zonesArray[i].type)
      this.zonesArray[i].name=zoneName.name+' ('+this.zonesPropertiesService.getZoneTypeNumber(this.zonesArray,this.zonesArray[i])+') '
    }

  }
  toggleAction(action: string){
    this.addZone=this.optionsService.toggleAction(action);
    if(!this.addZone)
      this.activeZone=null;
    else{
      for(let i=0; i<this.zonesArray.length;i++){
        if(this.zonesArray[i].id==this.activeZone.id)
        this.zonesArray[i].type=this.startingZoneType
      }
    }

      this.changeNames();
  }

  removeZone(zone){
    
    let activeZone=this.canvasOptionsService.getActiveZone();
    this.canvasOptionsService.clearAction();

    let index=this.elementsService.getElementIndexById('zones',zone.id)
    let properties=this.elementsService.removeZoneById(zone.id);
    if(zone.id==activeZone.id){
      this.canvasOptionsService.setActiveZone(null,null)
    }
    this.undoService.addAction('removeZone',{type:activeZone.name,zone:zone,index:index,properties:properties})
    this.optionsService.change('ZONE-ROOF-ADD','active',false);
    this.addZone=false
  }

  setActive(zone){
    this.canvasOptionsService.setActiveZone('ZONE-ROOF-EDIT',zone.id)
  }

}
